var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { Card } from "@irati/ui/src/Layout";
import { TextArea } from "@irati/ui/src/FormItem";
import Button from "@irati/ui/src/Button";
import { minWidthMedia } from "@irati/ui/src/global/media";
import { MessageHeader } from "./";
import { LoadingOverlay } from "../../ui/LoadingOverlay";
var StyledCard = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));
var TextWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  flex:1;\n  align-items: center;\n  ", "\n"], ["\n  width: 100%;\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  flex:1;\n  align-items: center;\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "]))));
var ButtonWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 15px;\n  display: flex;\n   ", "\n"], ["\n  margin-top: 15px;\n  display: flex;\n   ",
    "\n"])), minWidthMedia.tablet(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: 0;\n    margin-left: 15px;\n  "], ["\n    margin-top: 0;\n    margin-left: 15px;\n  "]))));
var StyledButton = styled(Button)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  min-width: 140px;\n  ", "\n"], ["\n  min-width: 140px;\n  ", "\n"])), function (_a) {
    var spaced = _a.spaced;
    return spaced && "margin-left: 15px;";
});
export var StyledTextArea = styled(TextArea)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width:100%;\n  flex: 1;\n  margin: 0;\n  padding: 0;\n  & textarea { min-height: 42px; }\n  > .col-xs-12 { padding:0; }\n "], ["\n  width:100%;\n  flex: 1;\n  margin: 0;\n  padding: 0;\n  & textarea { min-height: 42px; }\n  > .col-xs-12 { padding:0; }\n "])));
var AddMessage = /** @class */ (function (_super) {
    __extends(AddMessage, _super);
    function AddMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddMessage.prototype.render = function () {
        var _a = this.props, user = _a.user, className = _a.className, onSubmit = _a.onSubmit, onChange = _a.onChange, onCancel = _a.onCancel, loading = _a.loading, text = _a.text;
        return (React.createElement(LoadingOverlay, { loading: loading },
            React.createElement(StyledCard, { small: true },
                React.createElement(MessageHeader, { user: user }),
                React.createElement(TextWrapper, null,
                    React.createElement(StyledTextArea, { hideLabel: true, label: false, className: className + " clearfix", name: name, onChange: onChange, value: text, rows: 1 }),
                    React.createElement(ButtonWrapper, null,
                        React.createElement(StyledButton, { disabled: !text, onClick: onCancel }, "Cancel"),
                        React.createElement(StyledButton, { disabled: !text, onClick: onSubmit, primary: true, spaced: true }, "Send"))))));
    };
    return AddMessage;
}(Component));
export default AddMessage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
